import { createSlice, createAsyncThunk, isAllOf } from "@reduxjs/toolkit";

// ** Axios Imports
import { toast } from "react-toastify";
import httpService from "../../common/http.service";

export const appCreateAnnouncement = createAsyncThunk(
  "appAnnouncement/appCreateAnnouncement",
  async (params) => {
    try {
      const response = await httpService.post("/users/sendnotification", {}, params);
      if (response?.data) {
        toast.success("Announcement created Successfully");
      }
      return await response.data;
    } catch (error) {
      toast.error(error?.message);
    }
  }
);

export const appAnnouncementSlice = createSlice({
  name: "Announcement",
  initialState: {
    announcement: [],
    slugData: "",
    paginate: "",
    isloder: false,
    isdeleted: false,
  },
  reducers: {},
  extraReducers: (builder) => {

    builder.addMatcher(isAllOf(appCreateAnnouncement.pending), (state, action) => {
      state.isloder = true;
    });
    builder.addMatcher(isAllOf(appCreateAnnouncement.fulfilled), (state, action) => {
      state.announcement = action.payload;
      state.isloder = false;
    });
    builder.addMatcher(isAllOf(appCreateAnnouncement.rejected), (state, action) => {
      state.isloder = false;
    });
  },
});

export default appAnnouncementSlice.reducer;